// Guided audio in Explore → Relax. Files live in public/assets/relax/ (80 kbps
// mono copies; full-quality originals in the gitignored /assets/relax/).
//
// ⚠️ Replacing a recording: give it a NEW filename (e.g. -v2) rather than
// overwriting — public/ paths are stable, so a cached copy would otherwise keep
// playing. The service worker skips audio, but browsers and CDNs still cache.
//
// One entry per session, with a choice of voice inside it, so adding sessions
// doesn't double the list.
export const RELAX_SESSIONS = [
  {
    id: 'nothing-needed',
    title: 'Nothing Needed From You',
    minutes: 4,
    voices: [
      { id: 'female', label: 'Female voice', src: '/assets/relax/nothing-needed-female.mp3' },
      { id: 'male', label: 'Male voice', src: '/assets/relax/nothing-needed-male.mp3' },
    ],
  },
];
